module.exports = __webpack_public_path__ + "media/images/front/icon_trophy_silver-cd15dfed2d73a6d688a82ff74af3e806.png";